"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _OverlayOp = _interopRequireDefault(require("./OverlayOp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PointBuilder =
/*#__PURE__*/
function () {
  function PointBuilder() {
    _classCallCheck(this, PointBuilder);

    PointBuilder.constructor_.apply(this, arguments);
  }

  _createClass(PointBuilder, [{
    key: "filterCoveredNodeToPoint",
    value: function filterCoveredNodeToPoint(n) {
      var coord = n.getCoordinate();

      if (!this._op.isCoveredByLA(coord)) {
        var pt = this._geometryFactory.createPoint(coord);

        this._resultPointList.add(pt);
      }
    }
  }, {
    key: "extractNonCoveredResultNodes",
    value: function extractNonCoveredResultNodes(opCode) {
      for (var nodeit = this._op.getGraph().getNodes().iterator(); nodeit.hasNext();) {
        var n = nodeit.next();
        if (n.isInResult()) continue;
        if (n.isIncidentEdgeInResult()) continue;

        if (n.getEdges().getDegree() === 0 || opCode === _OverlayOp.default.INTERSECTION) {
          var label = n.getLabel();

          if (_OverlayOp.default.isResultOfOp(label, opCode)) {
            this.filterCoveredNodeToPoint(n);
          }
        }
      }
    }
  }, {
    key: "build",
    value: function build(opCode) {
      this.extractNonCoveredResultNodes(opCode);
      return this._resultPointList;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return PointBuilder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return PointBuilder;
}();

exports.default = PointBuilder;

PointBuilder.constructor_ = function () {
  this._op = null;
  this._geometryFactory = null;
  this._resultPointList = new _ArrayList.default();
  var op = arguments[0],
      geometryFactory = arguments[1],
      ptLocator = arguments[2];
  this._op = op;
  this._geometryFactory = geometryFactory;
};